(() => {
  const root = document.documentElement;
  if (root.hasAttribute('data-hsg-support-managed')) return;
  root.setAttribute('data-hsg-support-managed', '');
  const mobile = window.matchMedia('(max-width: 767px)');
  let bar;
  let resizeObserver;
  let stateObserver;
  let startupObserver;
  let startupTimeout;
  let offsetFrame = null;
  let suspended = false;

  const updateOffset = () => {
    offsetFrame = null;
    const visible = mobile.matches && bar?.isConnected && bar.dataset.position !== 'top' &&
      getComputedStyle(bar).visibility === 'visible';
    const height = visible ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    const value = `${height}px`;
    if (root.style.getPropertyValue('--hsg-mobile-cart-height') !== value) {
      root.style.setProperty('--hsg-mobile-cart-height', value);
    }
  };
  // Observer and focus/resize bursts share one layout measurement per frame.
  const scheduleOffset = () => {
    if (!suspended && offsetFrame === null) offsetFrame = requestAnimationFrame(updateOffset);
  };
  const bindBar = () => {
    const next = document.querySelector('.template-product cart-bar');
    if (bar !== next) {
      resizeObserver?.disconnect();
      stateObserver?.disconnect();
      bar?.removeEventListener('focusin', scheduleOffset);
      bar?.removeEventListener('focusout', scheduleOffset);
      bar?.removeEventListener('transitionend', scheduleOffset);
      bar = next;
      if (bar) {
        resizeObserver = new ResizeObserver(scheduleOffset);
        resizeObserver.observe(bar);
        stateObserver = new MutationObserver(scheduleOffset);
        stateObserver.observe(bar, { attributes: true, attributeFilter: ['class', 'data-position'] });
        bar.addEventListener('focusin', scheduleOffset);
        bar.addEventListener('focusout', scheduleOffset);
        bar.addEventListener('transitionend', scheduleOffset);
      }
    }
    scheduleOffset();
  };
  const stopStartup = () => {
    startupObserver?.disconnect();
    clearTimeout(startupTimeout);
  };
  const attachLauncher = (launcher) => {
    if (!launcher) return false;
    launcher.classList.add('hsg-mobile-support');
    if (!launcher.hasAttribute('aria-label')) launcher.setAttribute('aria-label', 'WhatsApp');
    stopStartup();
    return true;
  };
  const discoverLauncher = (records) => {
    for (const record of records) {
      // Some widgets assign the launcher class before appending their icon.
      if (record.target.nodeType === 1 && record.target.isConnected &&
        attachLauncher(record.target.closest('.shp-cnv-shipway-chat'))) return;
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1 || !node.isConnected) continue;
        const launcher = node.matches('.shp-cnv-shipway-chat') ? node :
          node.querySelector('.shp-cnv-shipway-chat');
        if (attachLauncher(launcher)) return;
      }
    }
  };
  const refresh = () => {
    suspended = false;
    bindBar();
    if (attachLauncher(document.querySelector('.shp-cnv-shipway-chat'))) return;
    stopStartup();
    startupObserver = new MutationObserver(discoverLauncher);
    startupObserver.observe(document.body, { childList: true, subtree: true });
    startupTimeout = setTimeout(stopStartup, 60000);
  };
  const suspend = () => {
    suspended = true;
    cancelAnimationFrame(offsetFrame);
    offsetFrame = null;
    stopStartup();
    resizeObserver?.disconnect();
    stateObserver?.disconnect();
    bar?.removeEventListener('focusin', scheduleOffset);
    bar?.removeEventListener('focusout', scheduleOffset);
    bar?.removeEventListener('transitionend', scheduleOffset);
    bar = null;
  };
  mobile.addEventListener('change', scheduleOffset);
  window.addEventListener('resize', scheduleOffset, { passive: true });
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('theme:product-info:loaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  refresh();
})();
